import { useEffect } from 'react'

import { AcquiringItem, RefillStyle, RefillType } from 'app/dataTypes/acquiring/settings'
import { StatusMessage } from 'app/common/templates-next/page-template'
import { BankCardId } from 'app/dataTypes/acquiring/recurrent/cards'

import Order from './Order'
import { RecurrentPayment } from './RecurrentPayment'

type Props = {
  acquiringItem: AcquiringItem | null
  amount: string
  refillType: RefillType | null
  successURL: string
  failureURL: string
  onRecurrent: (data: { bankId: BankCardId } | { save: boolean } | {} | null) => void
  onPrev: () => void
  onNext: (id: string) => void
}

const Step4 = ({
  acquiringItem,
  amount,
  refillType,
  successURL,
  failureURL,
  onRecurrent,
  onPrev,
  onNext,
}: Props) => {
  const amountFloat = parseFloat(amount)

  useEffect(() => {
    if (Number.isNaN(amountFloat)) {
      onPrev()
    }
  }, [amountFloat]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!acquiringItem || refillType === null) {
    return (
      <StatusMessage
        comment="Отсутствуют данные эквайринга или тип пополнения. Вернитесь к первому шагу и попробуйте снова"
        skipPadding
      >
        {'Произошла непредвиденная ошибка'}
      </StatusMessage>
    )
  }

  const { refillStyle } = acquiringItem

  if (refillStyle === RefillStyle.Recurrent) {
    return (
      <RecurrentPayment
        amount={amountFloat}
        acquiringItem={acquiringItem}
        refillType={refillType}
        onRecurrent={onRecurrent}
        onPrev={onPrev}
        onNext={() => onNext(acquiringItem.id)}
      />
    )
  }

  if (Number.isNaN(amountFloat)) {
    return null
  }

  return (
    <Order
      acquiringItem={acquiringItem}
      amount={amountFloat}
      refillType={refillType}
      successURL={successURL}
      failureURL={failureURL}
    />
  )
}

export default Step4
